import React, { useState, useEffect } from 'react';
import { Table, Toast, Header, Pagination, Button } from 'react-frontier';
import { Link } from 'react-router-dom';
import { EventPayout } from '../SiteClasses';
import { addCommas, bindClick } from '../SiteUtil';
import PayoutModal from './PayoutModal';
import moment from 'moment';
import API from '../API';
import { useUser } from '../hooks';
import UserAccess from '../UserAccess';

const PAGE_SIZE = 20;

interface PayoutsTableProps{
	dateId: number,
	user_coordinator: number,
}
enum Modals{
	PAYOUT = 1,
}

var PayoutsTable = (props: PayoutsTableProps)=>{
	var [payouts, setPayouts] = useState<EventPayout[]>([]);
	var [loading, setLoading] = useState<boolean>(true);
	var [shownModal, setShownModal] = useState<Modals>(null);
	var [page, setPage] = useState<number>(1);
	var { hasAccess, user } = useUser();

	useEffect(()=>{
		getPayouts();
	}, [props.dateId]);

	var getPayouts = (pageNumber: number = 1)=>{
		setLoading(true);
		var offset = (pageNumber - 1) * PAGE_SIZE;
		
		API.getEventPayouts(props.dateId, PAGE_SIZE, offset).then(res=>{
			if(res.error) return Toast.error(res.message);
			setPayouts(res.data);
			setPage(pageNumber);
		}).catch(err=>{
			Toast.error('Hubo un error cargando las liquidaciones (LCL-1)');
		}).finally(()=>{
			setLoading(false);
		});
	};

	var onPageChange = (newPage: number)=>{
		getPayouts(newPage);
	};

	var onPayoutCreated = (newPayout: EventPayout)=>{
		setPayouts([newPayout, ...payouts]);
		setShownModal(null);
	}

	return <>
		<Table fitted striped selectable
			title='Pagos aprobados'
			headers={['ID', 'Pagos', 'Creacion', 'Creador', 'Pagado', 'Pendiente', 'Total']}
			collapsingIndexes={[0, 1]}
			style={{ maxWidth: 800, margin: 'auto', marginTop: 20 }}
			button={(hasAccess(UserAccess.EVENTS.CREATE_EVENT_PAYOUT) || (props.user_coordinator && user?.user_id === props.user_coordinator)) && (
				<Button text='Aprobar' color='black' iconName='plus-circle' size='tiny' onClick={bindClick(setShownModal, Modals.PAYOUT)} />
			)}
			footer={(page > 1 || payouts.length >= PAGE_SIZE) && (
				<Pagination page={page} onPageChange={onPageChange} hasNext={payouts.length >= PAGE_SIZE} />
			)}
		>
			{loading ? (
				<Table.Row>
					<Table.Cell colSpan={7}>
						<Header loading text='Cargando datos...' />
					</Table.Cell>
				</Table.Row>
			) : payouts.length !== 0 ? (
				payouts.map(p => (
					<Table.Row
						compact
						collapsingIndexes={[0, 1, 2, 4, 5, 6, 7]}
						centeredIndexes={[1]}
						key={p.payout_id}
						as={Link}
						target={'_blank'}
						to={`/payouts/${p.payout_id}`}
						data={[
							p.payout_id,
							p.worker_count,
							moment.unix(p.date_created).format('DD/MM/YY HH:mm'),
							p.user_creator_name,
							'$' + addCommas(p.paid_amount),
							'$' + addCommas(p.pending_amount),
							'$' + addCommas(p.total_amount)
						]}
					/>
				))
			) : (
				<Table.Cell row className='empty' colSpan={7}>
					No se encontraron registros
				</Table.Cell>
			)}
			{payouts.length !== 0 && (
				<Table.Row>
					<Table.Cell colSpan={4} style={{ textAlign: 'right', fontSize: 14, fontWeight: 'bold' }}>
						Total:
					</Table.Cell>
					<Table.Cell collapsing colSpan={1} style={{ textAlign: 'start', fontSize: 14, fontWeight: 'bold' }}>
						${addCommas(payouts.reduce((sum, p) => sum + p.paid_amount, 0))}
					</Table.Cell>
					<Table.Cell collapsing colSpan={1} style={{ textAlign: 'start', fontSize: 14, fontWeight: 'bold' }}>
						${addCommas(payouts.reduce((sum, p) => sum + p.pending_amount, 0))}
					</Table.Cell>
					<Table.Cell collapsing colSpan={1} style={{ textAlign: 'start', fontSize: 14, fontWeight: 'bold' }}>
						${addCommas(payouts.reduce((sum, p) => sum + p.total_amount, 0))}
					</Table.Cell>
				</Table.Row>
			)}
		</Table>
		<PayoutModal
			onClose={bindClick(setShownModal, null)}
			open={shownModal===Modals.PAYOUT}
			date_id={props.dateId}
			onCreate={onPayoutCreated}
		/>
	</>
};

export default PayoutsTable;
